
import {css} from 'lit';
// eslint-disable-next-line import/prefer-default-export
export const style = css`/**
 * @tokens Hidden
 */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * @tokens Padding Sizes
 * @presenter Spacing
 */
/**
 * @tokens Border Radiuses
 * @presenter BorderRadius
 */
/**
 * @tokens Hidden
 */
/**
 * Border / offset sizes
 */
:host {
  display: block;
  font-family: var(--slh-default-font-family, "Open Sans");
  width: 100%;
}
:host .pt-s {
  padding-top: 8px;
}
:host .pt-l {
  padding-top: 16px;
}
:host .pt-xl {
  padding-top: 24px;
}
:host .card-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  border-radius: 16px;
  overflow: hidden;
}
:host .card-container:focus-visible {
  outline: none;
  box-shadow: 0 0 0 2px var(--slh-color-outline, #4C49D4);
  filter: drop-shadow(0px 8px 24px var(--slh-color-neutral-shade-80-opacity-12, rgba(78, 94, 126, 0.16)));
  -webkit-filter: drop-shadow(0px 8px 24px var(--slh-color-neutral-shade-80-opacity-12, rgba(78, 94, 126, 0.16)));
}
:host .card-container .image-container {
  position: relative;
  flex: 1;
}
:host .card-container .content-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: var(--slh-color-neutral-shade-00, #FFFFFF);
  flex: 0;
}
:host .card-container .content-container .content-holder {
  width: 100%;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}
:host .card-container .content-container.padding-sm {
  padding: 16px;
}
:host .card-container .content-container.padding-md {
  padding: 24px;
}
:host .card-container slot {
  display: block;
}
:host .card-container slot.hidden {
  display: none !important;
}
:host .card-container slot[name=state] {
  position: absolute;
  top: 16px;
  right: 16px;
  display: block;
  z-index: 1;
}
:host .card-container slot[name=image] {
  height: 100%;
  background-color: var(--slh-color-neutral-shade-00, #FFFFFF);
  overflow: hidden;
}
:host .card-container slot[name=image]::slotted(img) {
  object-fit: cover;
  height: 100%;
  width: 100%;
  position: relative;
  display: flex;
  justify-content: right;
  min-height: 40px;
  flex-wrap: wrap;
}
:host .card-container slot[name=title] {
  color: var(--slh-color-neutral, #39455D);
  flex-grow: 1;
}
:host .card-container slot[name=title], :host .card-container slot[name=title]::slotted(*) {
  font-size: var(--slh-base-m-font-size, 16px);
  line-height: var(--slh-base-xxs-line-height, 24px);
  font-weight: var(--slh-base-bold-font-weight, 700);
}
:host .card-container slot[name=content]::slotted(*) {
  font-size: var(--slh-base-xxs-font-size, 12px);
  line-height: var(--slh-base-xxs-line-height, 24px);
  font-weight: var(--slh-base-semi-bold-font-weight, 600);
  display: flex;
  align-items: center;
  color: var(--slh-color-neutral-shade-60, #62779F);
}
:host .card-container slot[name=actions] {
  display: flex;
}
:host .card-container slot[name=actions]::slotted(.button-wrapper:not(:last-of-type)), :host .card-container slot[name=actions]::slotted(.link-wrapper:not(:last-of-type)) {
  margin-right: 16px;
}
:host .card-container.elevated1 {
  filter: drop-shadow(0px 6px 12px var(--slh-color-neutral-shade-80-opacity-12, rgba(78, 94, 126, 0.12)));
  -webkit-filter: drop-shadow(0px 6px 12px var(--slh-color-neutral-shade-80-opacity-12, rgba(78, 94, 126, 0.12)));
}
:host .card-container.disabled slot[name=title] {
  color: var(--slh-color-neutral-shade-40, #C0C8D8);
}
:host .card-container.disabled slot[name=image]::slotted(img) {
  filter: grayscale(100%);
  -webkit-filter: grayscale(100%);
  -moz-filter: grayscale(100%);
  -ms-filter: grayscale(100%);
  -o-filter: grayscale(100%);
  opacity: 0.8;
}
@media only screen and (max-width: 560px) {
  :host .card-container.two-column {
    cursor: pointer;
  }
  :host .card-container.two-column .content-container {
    display: flex;
    flex-direction: row;
  }
  :host .card-container.two-column .content-container .content-holder {
    order: 1;
    padding-left: 8px;
  }
  :host .card-container.two-column .content-container .content-holder slot[name=content] {
    margin-bottom: 0;
  }
  :host .card-container.two-column .content-container slot[name=actions]::slotted(slh-button) {
    margin-right: 0;
  }
  :host .card-container.two-column .content-container slot[name=actions]::slotted(slh-button.hide) {
    display: none;
  }
  :host .card-container.two-column .content-container slot[name=actions] {
    order: 0;
    width: auto;
    padding-right: 8px;
    flex: 0;
    flex-direction: column;
    padding-top: 0;
  }
}
`;
